import React from "react";
import { Route } from "react-router-dom";
import Screening from "../Screening/Screening";
import Email from "../Email/Email";
import Phone from "../Phone/Phone";
import Personal from "../Personal/Personal";
import CreditReport from "../CreditReport/CreditReport";
import PaymentScheduling from "../PaymentScheduling/PaymentScheduling";
import CreditSelect from "../CreditSelect/CreditSelect";
import Location from "../Location/Location";
import Review from "../Review/Review";
import PaymentInformation from "../PaymentInformation/PaymentInformation";
import Plan from "../Plan/Plan";
import Success from "../Success/Success";
import CustomPage from "../CustomPage/CustomPage";

const ComponentMap = {
  screening: Screening,
  email: Email,
  phone: Phone,
  personal: Personal,
  credit_report: CreditReport,
  payment_scheduling: PaymentScheduling,
  credit_select: CreditSelect,
  location: Location,
  review: Review,
  payment_info: PaymentInformation,
  plan: Plan,
  success: Success,
};

export const getSettings = (flow, pageName) => {
  // First try to find by pageId (for custom pages), then by name
  return (
    flow.find((page) => page.pageId === pageName) ||
    flow.find((page) => page.name === pageName)
  );
};

export const generateRoute = (flow, pageName, isRoot = false) => {
  // Check if this is a custom page (starts with custom_)
  const isCustomPage = pageName.startsWith("custom_");

  if (isCustomPage) {
    const pageSettings = getSettings(flow, pageName);
    // Use the slug from the custom page data for the URL
    const slug = pageSettings?.customPageData?.slug || pageName;
    return (
      <Route
        key={pageName}
        exact
        path={isRoot ? "/" : `/${slug}`}
        id={pageName}
        element={<CustomPage settings={pageSettings} />}
      />
    );
  }

  const Component = ComponentMap[pageName];
  if (!Component) return null;
  return (
    <Route
      key={pageName}
      exact
      path={isRoot ? "/" : `/${pageName}`}
      id={pageName}
      element={<Component settings={getSettings(flow, pageName)} />}
    />
  );
};

export const generateRootRoute = (flow) => {
  return generateRoute(flow, "screening", true);
};
